import React from 'react';

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "@material-ui/core/Button";

import Header from './components/Header/Header';
import Parallax from './components/Parallax/Parallax';

import logo from './logo.svg';

import "./assets/jss/material-kit-react/components/typographyStyle";
import "./App.css";

import PortfolioSection from './sections/portfolio';
import AboutSection from './sections/about';
import ContactSection from './sections/contact';

export default class App extends React.Component {
  render() {
    return (
      <div>
        <Header
          brand={<img src={require('assets/img/izziel.jpg')} className="logo" />}
          color="white"
          fixed
          rightLinks={
            <div class="social-container">
              <div class="social-container-inner">
                <Button className="social-button" href="https://www.instagram.com/izziellatour/?hl=nl">
                  <img src={require('assets/img/insta.png')} className="social" />
                </Button>
                <Button className="social-button" href="https://www.facebook.com/izziel.photography/">
                  <img src={require('assets/img/facebook.png')} className="social" />
                </Button>
                <Button className="social-button" href="mailto:mail@izziel.nl">
                  <img src={require('assets/img/email.png')} className="social" style={{ height: '26px' }} />
                </Button>
              </div>
            </div>
          }
        />
        {/* <div className="header">
          <div className="header-avatar">
          <img src={logo} />
          </div>      
        </div> */}
        <main className="container">
          <section>
            <PortfolioSection/>
          </section>
          <section className="padded">
            <AboutSection/>
          </section>
        </main>

      </div>
    );
  }
}
